<template>
  <div
    class="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100 flex items-center justify-center p-4"
  >
    <div class="max-w-md w-full text-center">
      <!-- 404图标 -->
      <div class="mb-8">
        <div
          class="w-32 h-32 mx-auto bg-gradient-to-r from-blue-500 to-purple-600 rounded-full flex items-center justify-center shadow-lg"
        >
          <SearchX class="w-16 h-16 text-white" />
        </div>
      </div>

      <!-- 错误信息 -->
      <div class="mb-8">
        <h1 class="text-6xl font-bold text-gray-800 mb-2">404</h1>
        <h2 class="text-xl font-semibold text-gray-600 mb-3">页面未找到</h2>
        <p class="text-gray-500 leading-relaxed">
          抱歉，您访问的页面不存在或已被移除。<br />
          请检查网址是否正确，或返回首页重新开始。
        </p>
      </div>

      <!-- 操作按钮 -->
      <div class="space-y-3">
        <button
          @click="goHome"
          class="w-full bg-gradient-to-r from-blue-500 to-purple-600 text-white py-3 px-6 rounded-lg font-medium shadow-lg hover:shadow-xl transition-all duration-200 transform hover:scale-105 active:scale-95"
        >
          <Home class="w-5 h-5 inline-block mr-2" />
          返回首页
        </button>

        <button
          @click="goBack"
          class="w-full bg-white text-gray-600 py-3 px-6 rounded-lg font-medium border border-gray-200 shadow-sm hover:shadow-md transition-all duration-200 transform hover:scale-105 active:scale-95"
        >
          <ArrowLeft class="w-5 h-5 inline-block mr-2" />
          返回上页
        </button>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { SearchX, Home, ArrowLeft } from 'lucide-vue-next'
import { useRouter } from 'vue-router'

const router = useRouter()

const goHome = () => {
  router.push('/')
}

const goBack = () => {
  // 如果有历史记录则返回，否则跳转到首页
  if (window.history.length > 1) {
    router.go(-1)
  } else {
    router.push('/')
  }
}
</script>
